<template>
  <div>
    <page-header :title="$t('system.text_23')" />
    <page-body>
      <list />
    </page-body>
  </div>
</template>

<script>
import List from './components/List'

export default {
  name: 'DictionarySettingIndex',
  components: {
    List,
  },
}
</script>
